import { useEffect } from 'react';
import type { SecondaryMarketServiceRootResponse } from 'src/apis/secondary-market-service/types';
import { useAxios } from 'src/hooks/use-axios';

type ExecuteProps = {
  secondaryMarketService: string;
};

export function useSecondaryMarketService() {
  const request = useAxios(
    (axios, baseConfig, { secondaryMarketService }: ExecuteProps) =>
      axios.request<SecondaryMarketServiceRootResponse>({
        ...baseConfig,
        url: secondaryMarketService,
      }),
    { neededOnPageLoad: true, cacheKey: 'secondary-market-service-root' }
  );
  const secondaryMarketService = PRISMA_CONFIG.secondaryMarketService;

  useEffect(() => {
    if (!secondaryMarketService) return;
    request.execute({ secondaryMarketService });
    // oxlint-disable-next-line exhaustive-deps
  }, [secondaryMarketService]);

  return request;
}

export type SecondaryMarketServiceRequest = ReturnType<
  typeof useSecondaryMarketService
>;
